import api from "./client";

export async function getUploadedFiles() {
  const { data } = await api.get("/api/upload/files");
  return data;
}

export async function deleteUploadedFile(filename, force = false) {
  const { data } = await api.delete(`/api/upload/files/${filename}${force ? "?force=true" : ""}`);
  return data;
}
